import styled from 'styled-components';
import {dFlexCenter} from '../../../../../../globalVariables/GlobalFlex';
import {desktopMedia, LIGHT_GRAY} from '../../../../../../globalVariables/GlobalVariables';

export const pill = styled.div`
    width: 100%;
    height: 44px;
    ${dFlexCenter}
    gap: var(--space-sm);
    padding-inline: var(--space-lg);
    background: ${p => p.theme.isDarkMode ? LIGHT_GRAY : 'var(--primitive-black)'};
    color: ${p => p.theme.isDarkMode ? '#1E1E1E' : 'var(--color-text-inverse-default)'};
    border-radius: var(--radius-full);
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    white-space: nowrap;
    ${desktopMedia}{
        width: 243px;
    }
`;
